// Mapping of canonical type keys to display names
// Synced with backend/canonical_taxonomy.py CANONICAL_TYPES

export const CANONICAL_TYPE_DISPLAY_NAMES = {
  "single_dose_espresso_grinder": "Single Dose Espresso Grinder",
  "single_dose_allrounder_grinder": "Single Dose Allrounder Grinder",
  "single_dose_filter_grinder": "Single Dose Filter Grinder",
  "hybrid_portable_grinder": "Hybrid Portable Grinder",
  "hopper_espresso_grinder": "Hopper Espresso Grinder",
  "hand_grinder_espresso": "Hand Grinder (Espresso)",
  "hand_grinder_filter": "Hand Grinder (Filter)",
  "hand_grinder_allrounder": "Hand Grinder (Allrounder)",
  "burr_set": "Replacement Burr Set",
  "semi_auto_espresso_machine": "Semi-Automatic Espresso Machine",
  "portable_espresso_machine": "Portable Espresso Machine",
  "lever_espresso_machine": "Lever/Manual Espresso Machine",
  "automatic_espresso_machine": "Automatic Espresso Machine",
  "integrated_espresso_machine": "Integrated Espresso Machine (with Grinder)",
  "integrated_filter_brewer": "Integrated Filter Brewer (with Grinder)",
  "automatic_pour_over": "Automatic Pour Over",
  "pour_over_dripper": "Pour-Over Dripper",
  "vacuum_brewer": "Vacuum/Siphon Brewer",
  "espresso_accessory": "Espresso Accessory",
  "equipment_stand": "Equipment Stand",
  "bottomless_portafilter": "Bottomless Portafilter",
  "milk_pitcher": "Milk Pitcher",
  "coffee_scale": "Coffee Scale",
  "coffee_scale_espresso": "Espresso Scale (Compact)",
  "tamper": "Espresso Tamper",
  "tamper_precision": "Precision/Self-Leveling Tamper",
  "wdt_tool": "WDT Distribution Tool",
  "distributor": "Leveling Distributor",
  "tamping_station": "Tamping Station",
  "tamping_mat": "Tamping Mat",
  "knock_box": "Knock Box/Drawer",
  "dosing_cup": "Dosing Cup",
  "dosing_tube": "Dosing Tube/Vial",
  "precision_basket": "Precision Filter Basket",
  "portafilter_funnel": "Portafilter Dosing Funnel",
  "milk_foamer": "Electric Milk Foamer",
  "kettle_gooseneck_electric": "Electric Gooseneck Kettle",
  "kettle_gooseneck_manual": "Manual Gooseneck Kettle",
  "glass_server": "Glass Server/Carafe",
  "travel_case": "Equipment Travel Case",
  "grinder_accessory": "Grinder Accessory",
  "coffee_beans": "Coffee Beans",
  "filter_paper": "Filter Papers",
  "chai_tea": "Chai/Tea",
  "drinkware": "Drinkware/Mug",
  "travel_mug": "Travel Mug/Tumbler",
  "bundle": "Product Bundle",
  "gift_card": "Gift Card",
  "spare_part": "Spare Part"
};

/**
 * Display name for a canonical type key.
 * @param {string} typeKey
 * @param {string} [displayName] — `canonical_type_display_name` aus der product_taxonomy-Zeile;
 *   gesetzt gewinnt er. Die Handliste unten ist das KAFFEE-Profil; andere Verticals
 *   (Peak Blades) stehen nur im canonical_type_registry (Spec 2026-10-12 §7).
 * @returns {string} The display name, the key itself when nothing is known, '' for an empty key
 */
export function getCanonicalTypeDisplayName(typeKey, displayName) {
  if (displayName) return displayName;
  if (!typeKey) return '';
  return CANONICAL_TYPE_DISPLAY_NAMES[typeKey] || typeKey;
}

// Canonical types that ARE spare parts. Mirror of backend
// SPARE_PART_CANONICAL_TYPES in backend/taxonomy_enhancements.py.
export const SPARE_PART_CANONICAL_TYPES = new Set(['spare_part', 'burr_set']);

/**
 * Beide Schreibweisen von equipment_category, die im Bestand vorkommen.
 *
 * 🔴 Ab 2026-08-19 fuehrt das canonical_type_registry das Vokabular, und es
 * schreibt MEHRZAHL ('spare_parts'). Der Altbestand traegt die Einzahl. Ein
 * Vergleich gegen nur eine der beiden Formen verliert stillschweigend Zeilen —
 * hier waeren es alle Ersatzteile gewesen, sobald der Backfill laeuft.
 * Gegenstueck im Backend: backend/taxonomy_categories.ist_kategorie().
 */
const SPARE_PART_CATEGORIES = new Set(['spare_part', 'spare_parts']);

/**
 * True iff the effective (override-merged) taxonomy marks a product as a spare
 * part. equipment_category wins when it says so (either spelling); otherwise
 * fall back to canonical_type (the reliably populated backbone).
 * null/empty → false.
 *
 * @param {{canonical_type?: string, equipment_category?: string}|null} tax
 * @returns {boolean}
 */
export function isSparePartTaxonomy(tax) {
  if (!tax) return false;
  if (SPARE_PART_CATEGORIES.has((tax.equipment_category || '').trim().toLowerCase())) return true;
  return SPARE_PART_CANONICAL_TYPES.has((tax.canonical_type || '').trim());
}
